// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/sidebar.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General styles for the sidebar */
.sidebar_main {
    position: relative;
    width: 100%;
    max-width: 23.25rem;
    /* 372px */
    height: auto;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 2;
    padding: 1rem;
}

.sidebar_main::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(104% 47.97% at 50% 52.03%, #082B23 0%, #10182F 100%);
    opacity: 0.95;
    pointer-events: none;
}

.sidebar_content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 0px;
    gap: 6px;
    position: relative;
    max-width: 322px;
    width: 100%;
    height: auto;
    margin: 0 auto;
    border-radius: 16px;
}

.sidebar_content .company_logo {
    width: 185.89px;
    height: 42px;
    margin: 2rem 0;
}

.sidebar_content .sidebar_frame {
    display: flex;
    flex-direction: column;
    width: 100%;
    /* gap: 6rem; */
    justify-content: space-between;
}

.sidebar_content .links {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 12px;
    border-radius: 16px 0px 0px 0px;
    justify-content: space-between;
}

.sidebar_content .links li {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 48px;
    padding: 16px 20px;
    gap: 16px;
    border-radius: 12px;
    font-family: Lexend;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    color: rgba(255, 255, 255, 1);
}

.sidebar_content .active {
    background: rgba(27, 144, 117, 1);
}

.sidebar_content .links li img {
    width: 32px;
    height: 32px;
}

.sidebar_content .calendar {
    width: 100%;
    height: auto;
    gap: 10px;
}

.calendar_main {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 24px;
    gap: 21px;
    border-radius: 12px;
    background: #FFFFFF;
    box-shadow: 0px 3px 15px 0px rgba(238, 238, 238, 0.5);
}

.react-calendar__navigation {
    display: flex;
    width: 100%;
    gap: 0px;
    justify-content: space-between;
    font-family: Lexend;
    font-size: 14px;
    font-weight: 900;
    color: #4A5660;
}

.react-calendar__month-view__days {
    margin-top: 1rem;
}

.react-calendar__month-view__weekdays {
    width: 100%;
    height: 20px;
}

.react-calendar__month-view__weekdays__weekday {
    width: 25px;
    height: 20px;
    font-family: Lexend;
    font-size: 10px;
    font-weight: 900;
    letter-spacing: 1.5px;
    text-align: center;
    color: #B5BEC6;
}

abbr {
    text-decoration: none !important;
}

.calendar_dates {
    display: flex;
    width: 30px;
    height: 30px;
    align-items: center;
    justify-content: center;
    font-family: Lexend;
    font-size: 16px;
    font-weight: 400;
    color: #151D48;
}

.react-calendar__tile--now {
    background-color: #F04D23 !important;
    border-radius: 29px !important;
    color: #FFFFFF;
}

.calendar_dates:enabled:hover,
.calendar_dates:enabled:focus {
    background: #F04D23 !important;
    border-radius: 29px !important;
    color: #FFFFFF;
}

.react-calendar__navigation__arrow:hover,
.react-calendar__navigation__arrow:focus {
    background: #fff !important;
}

.close_icon {
    display: none;
}

/* media queries responsive styles */
@media (max-width: 1024px) {
    .sidebar_main {
        max-width: 20rem;
    }
}

@media (max-width: 768px) {
    .sidebar_main {
        overflow-y: scroll;
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        width: 20rem;
        z-index: 1000;
        transform: translateX(-100%);
        transition: transform 0.3s ease-in-out;
    }

    .sidebar_main::before {
        height: 100%;
    }

    .sidebar_main.active {
        transform: translateX(0);
    }

    .sidebar_content {
        padding: 1rem;
    }

    .close_icon {
        display: block;
        margin-left: auto;
    }
}

@media (max-width: 480px) {
    .sidebar_main {
        width: 100%;
        max-width: none;
    }

    .sidebar_content .company_logo {
        width: 150px;
    }

    .sidebar_content .links li {
        font-size: 14px;
        padding: 12px 16px;
    }

    .close_icon {
        display: block;
        margin-left: auto;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/sidebar.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,yDAAqD;IACrD,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gFAAgF;IAChF,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,SAAS;IACT,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,qDAAqD;AACzD;;AAEA;IACI,aAAa;IACb,WAAW;IACX,QAAQ;IACR,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;;IAEI,8BAA8B;IAC9B,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA,oCAAoC;AACpC;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,eAAe;QACf,OAAO;QACP,MAAM;QACN,SAAS;QACT,YAAY;QACZ,aAAa;QACb,4BAA4B;QAC5B,sCAAsC;IAC1C;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ","sourcesContent":["/* General styles for the sidebar */\n.sidebar_main {\n    position: relative;\n    width: 100%;\n    max-width: 23.25rem;\n    /* 372px */\n    height: auto;\n    background-image: url('../assets/images/sidebar.png');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    z-index: 2;\n    padding: 1rem;\n}\n\n.sidebar_main::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: radial-gradient(104% 47.97% at 50% 52.03%, #082B23 0%, #10182F 100%);\n    opacity: 0.95;\n    pointer-events: none;\n}\n\n.sidebar_content {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0px;\n    gap: 6px;\n    position: relative;\n    max-width: 322px;\n    width: 100%;\n    height: auto;\n    margin: 0 auto;\n    border-radius: 16px;\n}\n\n.sidebar_content .company_logo {\n    width: 185.89px;\n    height: 42px;\n    margin: 2rem 0;\n}\n\n.sidebar_content .sidebar_frame {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    /* gap: 6rem; */\n    justify-content: space-between;\n}\n\n.sidebar_content .links {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 12px;\n    border-radius: 16px 0px 0px 0px;\n    justify-content: space-between;\n}\n\n.sidebar_content .links li {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 48px;\n    padding: 16px 20px;\n    gap: 16px;\n    border-radius: 12px;\n    font-family: Lexend;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 20px;\n    color: rgba(255, 255, 255, 1);\n}\n\n.sidebar_content .active {\n    background: rgba(27, 144, 117, 1);\n}\n\n.sidebar_content .links li img {\n    width: 32px;\n    height: 32px;\n}\n\n.sidebar_content .calendar {\n    width: 100%;\n    height: auto;\n    gap: 10px;\n}\n\n.calendar_main {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: 24px;\n    gap: 21px;\n    border-radius: 12px;\n    background: #FFFFFF;\n    box-shadow: 0px 3px 15px 0px rgba(238, 238, 238, 0.5);\n}\n\n.react-calendar__navigation {\n    display: flex;\n    width: 100%;\n    gap: 0px;\n    justify-content: space-between;\n    font-family: Lexend;\n    font-size: 14px;\n    font-weight: 900;\n    color: #4A5660;\n}\n\n.react-calendar__month-view__days {\n    margin-top: 1rem;\n}\n\n.react-calendar__month-view__weekdays {\n    width: 100%;\n    height: 20px;\n}\n\n.react-calendar__month-view__weekdays__weekday {\n    width: 25px;\n    height: 20px;\n    font-family: Lexend;\n    font-size: 10px;\n    font-weight: 900;\n    letter-spacing: 1.5px;\n    text-align: center;\n    color: #B5BEC6;\n}\n\nabbr {\n    text-decoration: none !important;\n}\n\n.calendar_dates {\n    display: flex;\n    width: 30px;\n    height: 30px;\n    align-items: center;\n    justify-content: center;\n    font-family: Lexend;\n    font-size: 16px;\n    font-weight: 400;\n    color: #151D48;\n}\n\n.react-calendar__tile--now {\n    background-color: #F04D23 !important;\n    border-radius: 29px !important;\n    color: #FFFFFF;\n}\n\n.calendar_dates:enabled:hover,\n.calendar_dates:enabled:focus {\n    background: #F04D23 !important;\n    border-radius: 29px !important;\n    color: #FFFFFF;\n}\n\n.react-calendar__navigation__arrow:hover,\n.react-calendar__navigation__arrow:focus {\n    background: #fff !important;\n}\n\n.close_icon {\n    display: none;\n}\n\n/* media queries responsive styles */\n@media (max-width: 1024px) {\n    .sidebar_main {\n        max-width: 20rem;\n    }\n}\n\n@media (max-width: 768px) {\n    .sidebar_main {\n        overflow-y: scroll;\n        position: fixed;\n        left: 0;\n        top: 0;\n        bottom: 0;\n        width: 20rem;\n        z-index: 1000;\n        transform: translateX(-100%);\n        transition: transform 0.3s ease-in-out;\n    }\n\n    .sidebar_main::before {\n        height: 100%;\n    }\n\n    .sidebar_main.active {\n        transform: translateX(0);\n    }\n\n    .sidebar_content {\n        padding: 1rem;\n    }\n\n    .close_icon {\n        display: block;\n        margin-left: auto;\n    }\n}\n\n@media (max-width: 480px) {\n    .sidebar_main {\n        width: 100%;\n        max-width: none;\n    }\n\n    .sidebar_content .company_logo {\n        width: 150px;\n    }\n\n    .sidebar_content .links li {\n        font-size: 14px;\n        padding: 12px 16px;\n    }\n\n    .close_icon {\n        display: block;\n        margin-left: auto;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
